<template>
  <a href="#" @click.prevent="loginFacebook">
    <span class="sns-center">
      <span class="icon-sns icon-facebook"></span>
      <span class="txt-sns">페이스북으로 시작하기</span>
    </span>
  </a>
</template>

<script>
/* eslint-disable no-undef */
import { setLibFile } from '@/common/plugins/sns.lib'
import utils from '@/common/util/utils'
import { parseUrl, stringify } from 'query-string'
import { get } from 'lodash'

export default {
  name: 'BtnFaceBook',
  data () {
    return {
      signupResultCode: '302'
    }
  },
  props: {
    showProfileFn: {
      type: Function
    },
    closeOnSuccessFn: {
      type: Function
    },
    promotionCode: {
      type: String
    }
  },
  methods: {
    login (token) {
      utils.login.loginProc({
        userType: 'facebook',
        userId: token,
        userPassword: '',
        saveId: '',
        autoLogin: ''
      }, (error) => {
        if (error.response.status === 551 && get(error, 'response.data.resultoptional', '') !== '' &&
          error.response.data.resultcode === this.signupResultCode) {
          const { url, query } = parseUrl(error.response.data.resultoptional)
          if (this.promotionCode !== '') query.promotioncode = this.promotionCode
          window.location.href = `${url}?${stringify(query)}`
        } else {
          const errorMessage = get(error, 'response.data.resultmessage', '')
          if (errorMessage !== '') {
            alert(errorMessage)
          }
          window.location.href = '/member/login.html'
        }
      }).then(({ data }) => {
        if (data.needselectprofile === 'y') { // 프로필 선택 화면이 필요하면
          this.showProfileFn()
        } else {
          this.closeOnSuccessFn()
        }
      })
    },
    // 페이스북 로그인 처리
    loginFacebook () {
      const self = this
      FB.getLoginStatus(function (statusResponse) {
        // 이미 로그인 상태일 때
        if (statusResponse.status === 'connected') {
          self.login(statusResponse.authResponse.accessToken)
        } else {
          // 페이스북 로그인 안돼있는 상태일 때 페이스북 로그인 처리
          FB.login(function (facebookLoginResponse) {
            // 로그인에 성공했을 때 로그인 처리
            if (facebookLoginResponse.status === 'connected') {
              self.login(facebookLoginResponse.authResponse.accessToken)
            }
            // public_profile,email : 이메일 주소와 친구의 목록에 접근하는 권한 요청
          }, { scope: 'public_profile' })
        }
      })
    }
  },
  created () {
    // 페이스북 SDK 초기화
    window.fbAsyncInit = function () {
      FB.init({
        appId: '1818575348440201',
        status: true,
        cookie: true, // 쿠키가 세션을 참조할 수 있도록 허용
        xfbml: true, // 소셜 플러그인이 있으면 처리
        version: 'v4.0' // 버전 4.0 사용
      })
    }
    setLibFile(document, 'script', 'facebook-jssdk', '//connect.facebook.net/ko_KR/sdk.js')
  }
}
</script>
